import { z } from "zod";

const currentYear = new Date().getFullYear();

export const createMasterBudgetSchema = z.object({
  name: z.string().trim().min(1, "Name is required"),
  description: z.string().optional(),
  year: z.number().int().min(currentYear, "Year must be current or future"),
});

export const editMasterBudgetSchema = z.object({
  name: z.string().trim().min(1, "Name is required"),
  description: z.string().optional(),
  // year is intentionally excluded — not editable after creation
});

export const cloneMasterBudgetSchema = z.object({
  name: z.string().trim().min(1, "Name is required"),
  description: z.string().optional(),
  targetYear: z
    .number()
    .int()
    .min(currentYear + 1, "Target year must be in the future"),
});

export type CreateMasterBudgetInput = z.infer<typeof createMasterBudgetSchema>;
export type EditMasterBudgetInput = z.infer<typeof editMasterBudgetSchema>;
export type CloneMasterBudgetInput = z.infer<typeof cloneMasterBudgetSchema>;
